import * as actionTypes from "./actionTypes";
// import { staffs } from "../../data";
import { firebase } from "../../firebase/index";
import { collections } from "../../firebase/firestoreNameSpaces";
import { sigInWithCustomToken, signInStaff, logout } from "./auth";

export const onAddStaff = (newStaff) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { addStaffLoading: true },
    });
    try{
      //Checking if Admin is logged in or not
      if (!localStorage.getItem("credential")) {
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { addStaffLoading: false },
        });

        return alert("Something went wrong..Please logout and login again");
      }
      let credential = firebase.auth.AuthCredential.fromJSON(
        JSON.parse(localStorage.getItem("credential"))
      );
      //Signing Staff for getting staffId from goole auth provider
      let id  = await signInStaff(dispatch);
      console.log(id)
      //Again Signing the Admin with its credentials
      await sigInWithCustomToken(credential);
       
      let db = firebase.firestore();
      // let id = db.collection(collections.STAFFS).doc().id;
      newStaff["staffId"] = id;
      newStaff["status"] = true;
      if (!newStaff.admin) {
        newStaff["staff"] = true;
        // delete newStaff["admin"];
      }

      if (newStaff.admin) {
      
            db.collection(collections.STAFFS)
              .doc(id)
              .set(newStaff, { merge: true })
              .then(() => {
                dispatch({
                  type: actionTypes.UTILITY_CONTROLS,
                  payload: { addStaffLoading: false },
                });

                window.location.reload();
              })
              .catch(async (err) => {
                await sigInWithCustomToken(credential);
                dispatch({
                  type: actionTypes.UTILITY_CONTROLS,
                  payload: { addStaffLoading: false },
                });
                return alert(err);
              });
      
          
      } else {
        db.collection(collections.STAFFS)
          .doc(id)
          .set(newStaff, { merge: true })
          .then(() => {
            dispatch({
              type: actionTypes.UTILITY_CONTROLS,
              payload: { addStaffLoading: false },
            });

            window.location.reload();
          })
          .catch(async (err) => {
            await sigInWithCustomToken(credential);
            dispatch({
              type: actionTypes.UTILITY_CONTROLS,
              payload: { addStaffLoading: false },
            });
            return alert(err);
          });
      }


    }catch(err){
      dispatch({
        type:actionTypes.UTILITY_CONTROLS,
        payload:{addStaffLoading:false}
      })
    }
  };
};

export const onFetchStaff = (isStaff) => {
  return (dispatch) => {
    return new Promise((resolve,reject)=>{
      dispatch({
        type: actionTypes.UTILITY_CONTROLS,
        payload: { loading: true },
      });
      // dispatch({
      //   type: actionTypes.STUDENT_MANAGEMENT,
      //   payload: { staffDashboardLoading: true },
      // });
      let db = firebase.firestore(); 
      db.collection(collections.STAFFS) 
        .get() 
        .then((snapshot) => {
          let staffs = [];  
          snapshot.forEach((staff) => {
           
            if (staff.data().staffId != firebase.auth().currentUser.uid) {
              staffs.push(staff.data());
            }
          });
            
            dispatch({
              type: actionTypes.UTILITY_CONTROLS,
              payload: { staffs: staffs, loading: false },
            });
       
         
          resolve(true)
        })
        .catch((err) => {
          dispatch({
            type: actionTypes.UTILITY_CONTROLS,
            payload: { staffs: [], loading: false },
          });
          reject(err)
          return alert(err);
        });
    })
  };
};

export const onEditStaff = (staff) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { editStaffBtnLoading: true },
    });

    let db = firebase.firestore();

    db.collection(collections.STAFFS)
      .doc(staff.staffId)
      .update(staff)
      .then(() => {
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { editStaffBtnLoading: false },
        });
        window.location.reload();
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { editStaffBtnLoading: false },
        });
        return alert(err);
      });
  };
};

export const onToggleStaffStatus = (staffId, status) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { toggleStaffStatusBtnLoading: true },
    });

    let db = firebase.firestore();
    db.collection(collections.STAFFS)
      .doc(staffId)
      .update({
        status: !status,
      })
      .then(() => {
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { toggleStaffStatusBtnLoading: false },
        });
        window.location.reload();
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.UTILITY_CONTROLS,
          payload: { toggleStaffStatusBtnLoading: false },
        });
        return alert(err);
      });
  };
};

export const onDeleteStaff = (staffId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UTILITY_CONTROLS,
      payload: { deleteStaffBtnLoading: true },
    });
    
        let db = firebase.firestore();
        db.collection(collections.STAFFS)
          .doc(staffId.toString())
          .delete()
          .then(() => {
            dispatch({
              type: actionTypes.UTILITY_CONTROLS,
              payload: { deleteStaffBtnLoading: false },
            });
            return window.location.reload();
          })
          .catch((err) => {
            dispatch({
              type: actionTypes.UTILITY_CONTROLS,
              payload: { deleteStaffBtnLoading: false },
            });
            return alert(err);
          });
      
     
  };
};
